import React from 'react';
import './styles.css';
import { COLORS } from '../../../constants/texts';

interface Props {
    children: JSX.Element;
    color?: string;
    small?: boolean;
    fullWidth?: boolean;
}
const SafeArea: React.FC<Props> = ({ children, color = COLORS.WHITE, small = false, fullWidth = true }) => {
    return (
        <div className={small ? "safe-area w100 small-safe-area" : fullWidth ? "safe-area w100" : "safe-area"}
        //  style={{ backgroundColor: color }}
        >{children}</div>
    )
}
export default SafeArea;